import { render, staticRenderFns } from "./BlogPartnership.vue?vue&type=template&id=91805664"
import script from "./BlogPartnership.vue?vue&type=script&lang=js"
export * from "./BlogPartnership.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports